import { reportUnexpectedError } from '@/shared/infrastructure/observability/reportUnexpectedError'
import type { ClientRepository } from '../application/ClientRepository'

export function createResilientClientRepository(
  primary: ClientRepository,
  fallback: ClientRepository,
): ClientRepository {
  return {
    async list(filters) {
      try {
        return await primary.list(filters)
      } catch (error) {
        reportUnexpectedError(error, { feature: 'clients', operation: 'list', fallback: true })
        const result = await fallback.list(filters)
        return {
          ...result,
          meta: { ...result.meta, source: 'fixture-fallback', fallbackReason: 'CLIENTS_REMOTE_UNAVAILABLE' },
        }
      }
    },
    async getByReference(reference) {
      try {
        return await primary.getByReference(reference)
      } catch (error) {
        reportUnexpectedError(error, { feature: 'clients', operation: 'detail', fallback: true })
        const result = await fallback.getByReference(reference)
        return result
          ? {
              ...result,
              meta: {
                ...result.meta,
                source: 'fixture-fallback',
                fallbackReason: 'CLIENTS_REMOTE_UNAVAILABLE',
              },
            }
          : null
      }
    },
    create(command) {
      return primary.create(command)
    },
    findDuplicates(contact) {
      return primary.findDuplicates(contact)
    },
    updateStatus(command) {
      return primary.updateStatus(command)
    },
    update(command) {
      return primary.update(command)
    },
    listNotes(clientId) {
      return primary.listNotes(clientId)
    },
    createNote(command) {
      return primary.createNote(command)
    },
    updateNote(command) {
      return primary.updateNote(command)
    },
    softDeleteNote(noteId) {
      return primary.softDeleteNote(noteId)
    },
    setNotePinned(noteId, pinned) {
      return primary.setNotePinned(noteId, pinned)
    },
    dismissNoteFromOverview(noteId) {
      return primary.dismissNoteFromOverview(noteId)
    },
    getAdditionalContact(clientId) {
      return primary.getAdditionalContact(clientId)
    },
    upsertAdditionalContact(command) {
      return primary.upsertAdditionalContact(command)
    },
    deleteAdditionalContact(clientId) {
      return primary.deleteAdditionalContact(clientId)
    },
    delete(clientId) {
      return primary.delete(clientId)
    },
  }
}
